<template>
  <v-card class="bg-card rounded-xl py-5 px-md-0">
    <h4 class="text-center text-h4 mb-5">Cajas</h4>

    <v-data-table
      :headers="headers"
      :items="rows.items"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 rounded-lg mx-5"
    >
      <template v-slot:item.state="{ item }">
        <v-chip
          label
          :color="`${getColorState(item.isLogged)} lighten-4`"
          :class="`font-work-sans font-weight-bold ${getColorState(
            item.isLogged
          )}--text text-uppercase`"
          >{{ getState(item.isLogged) }}
        </v-chip>
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="rows.totalPages"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
        @input="onPageChange"
      ></v-pagination>
    </div>
  </v-card>
</template>

<script>
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'
const CashDeskRepository = Repository.get('cashDesks')

export default {
  name: 'CashDeskHome',
  mixins: [createPaginationMixin({ itemsPerPage: 30 })],
  data: () => ({
    headers: [
      {
        text: 'Número',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'number',
      },
      {
        text: 'Descripción',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'description',
      },
      {
        text: 'Estado',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'state',
      },
    ],
  }),
  sockets: {
    'connect-cashDesk': function ({ id }) {
      const index = this.rows.items.findIndex((item) => item.id === id)
      if (index > -1) {
        this.rows.items[index].isLogged = true
      }
    },

    'disconnect-cashDesk': function ({ id }) {
      const index = this.rows.items.findIndex((item) => item.id === id)
      if (index > -1) {
        this.rows.items[index].isLogged = false
      }
    },
  },
  methods: {
    fetchPage: function (params) {
      return CashDeskRepository.get(params)
    },
    getColorState: (state) => (state ? 'green' : 'red'),
    getState: (state) => (state ? 'Activo' : 'Inactivo'),
  },
}
</script>
